import { aboutValues, contactEmail, brandName } from "../data";

export default function About() {
  return (
    <section id="about" className="scroll-mt-20 bg-background-50">
      <div className="site-container py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10">
          <div>
            <span className="eyebrow text-primary-600">
              <i className="ri-information-line text-sm w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
              关于我们
            </span>
            <h2 className="mt-4 text-2xl md:text-4xl leading-snug text-foreground-950">
              为「清醒吃瓜」做一本
              <span className="text-primary-600">随手可查的手册</span>
            </h2>

            <p className="mt-5 text-sm md:text-[15px] leading-relaxed text-foreground-600">
              {brandName}是一档聚焦娱乐生态观察的独立内容栏目。我们不追逐八卦、不生产谣言，
              而是把散落在各处、常被情绪淹没的理性线索，系统整理成通俗易懂的预警知识与避雷方法。
            </p>
            <p className="mt-4 text-sm md:text-[15px] leading-relaxed text-foreground-600">
              我们相信：真正的娱乐自由，是既享受追星与吃瓜的快乐，又始终保有清醒的判断、独立的钱包与可随时转身的底气。
              本站所有内容坚持客观中立、就事论事，不做针对真实人物的事实定性，也不制造恐慌。
            </p>

            <div className="mt-6 rounded-lg border border-accent-200 bg-accent-50 p-5">
              <h3 className="flex items-center gap-2 text-sm font-bold text-accent-900">
                <i className="ri-chat-smile-3-line text-base w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
                来自吃瓜群众的心声
              </h3>
              <blockquote className="mt-2 text-sm leading-relaxed text-foreground-700">
                「以前追星总是一头热，看完这份清单才意识到，把喜欢留有余地，反而能爱得更久、更从容。」
              </blockquote>
              <p className="mt-2 text-xs text-foreground-500">—— 一位开始「提前设防」的读者</p>
            </div>

            <div className="mt-6 flex flex-col sm:flex-row sm:items-center gap-3">
              <a
                href={`mailto:${contactEmail}`}
                className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-5 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-send-line text-base w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
                联系我们
              </a>
              <span className="text-xs text-foreground-500 whitespace-nowrap">
                建议、纠错、选题交流：{contactEmail}
              </span>
            </div>
          </div>

          <div className="lg:pl-2">
            <div className="grid grid-cols-1 gap-4">
              {aboutValues.map((v) => (
                <article
                  key={v.title}
                  className="flex items-start gap-4 rounded-lg border border-background-200 bg-background-100/70 p-5"
                >
                  <span className="flex items-center justify-center w-11 h-11 rounded-lg bg-accent-500 text-foreground-950 shrink-0">
                    <i className={`${v.icon} text-xl w-6 h-6 flex items-center justify-center`} aria-hidden="true"></i>
                  </span>
                  <div>
                    <h3 className="text-base font-bold text-foreground-950">{v.title}</h3>
                    <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{v.desc}</p>
                  </div>
                </article>
              ))}
            </div>

            <div className="mt-5 rounded-lg border border-secondary-200 bg-secondary-50 p-5">
              <h3 className="flex items-center gap-2 text-sm font-bold text-secondary-900">
                <i className="ri-file-shield-2-line text-base w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
                内容原则
              </h3>
              <ul className="mt-3 space-y-2 text-sm leading-relaxed text-foreground-600">
                <li className="flex gap-2">
                  <i className="ri-check-line text-accent-600 w-4 h-4 flex items-center justify-center mt-1" aria-hidden="true"></i>
                  只做类型与方法论科普，不追着真实事件煽风点火。
                </li>
                <li className="flex gap-2">
                  <i className="ri-check-line text-accent-600 w-4 h-4 flex items-center justify-center mt-1" aria-hidden="true"></i>
                  倡导证据与常识优先，反对网络暴力与人格攻击。
                </li>
                <li className="flex gap-2">
                  <i className="ri-check-line text-accent-600 w-4 h-4 flex items-center justify-center mt-1" aria-hidden="true"></i>
                  欢迎理性探讨，拒绝人身攻击；不同观点以事实为前提共存。
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}